const myProjects = [
  {
    id: "01",
    image: "/images/project1.png",
    title: "Result Checker",
    description:
      "Developed a Full-Stack Result Management System using HTML, CSS, JavaScript, E.js, Node.js, MongoDB and following the MVC (Model-View-Controller) model. The system allows two types of users to log in via a navbar link on the homepage: Students and Admin.",
    technology: "HTML, CSS, JavaScript, Node.js,MongoDB and E.js",
    source: "https://github.com/CodeWithBilal/result-Checker",
  },
  {
    id: "02",
    image: "/images/project2.png",
    title: "Authentication Library",
    description:
      "Developed a library to streamline authentication for developers, eliminating the need to reinvent the wheel. The library allows developers to register and download authentication codes tailored to their specific needs at any time.",
    technology: "React.js, Node.js, Express, and MongoDB",
    source: "https://github.com/CodeWithBilal/AuthWiki_Team9",
    demoLink: "https://authwiki.netlify.app/",
  },
  {
    id: "03",
    image: "/images/project3.png",
    title: "Full-Stack Quiz App",
    description:
      "This is a full-stack quiz app designed to test a student's knowledge after learning concepts of different languages. If the student passes the quiz, they can receive a certificate. The app is hosted on Skills Access, a website that offers free web development learning resources. Users need to be authenticated to access the quiz section, even though all learning materials on the website are free.",
    technology: "JavaScript, Nodejs, Express, MongoDB, Ejs",
    source: "https://github.com/CodeWithBilal",
  },
  // {
  //   id: "04",
  //   image: "/images/project4.png",
  //   title: "Deploying a Flask API",
  //   description:
  //     "Deploy a Flask API App to a Kubernetes cluster using Docker, AWS EKS, CodePipeline, and CodeBuild.",
  //   technology:
  //     "Docker, Kubernets, AWS, EKS, CodePipeline, CodeBuild, Postgres, Python, Flask, javaScript, SQLalchemy",
  //   source:
  //     "https://github.com/CodeWithBilal/cd0157-Server-Deployment-and-Containerization",
  // },
  // {
  //   id: "05",
  //   image: "/images/project5.png",
  //   title: "Punk API Beer App",
  //   description:
  //     " A simple Bear App built with JavaScript using Punk API, It also show you if the Beer is available or not, I style it using normal styling though it looks like simple but amazing when going through it",
  //   technology: "javaScript, Api, CSS, HTML5 ",
  //   source: "https://github.com/CodeWithBilal/punk-beer-app",
  //   demoLink: "https://punkbeerapp.netlify.app/",
  // },
  // {
  //   id: "06",
  //   image: "/images/project6.png",
  //   title: "Movies Search App",
  //   description:
  //     "It is a simple application named Movies App, built with Ract.js using TMDb API that will helps you to find your favourate  latest movies, and some information about it like date of releasing and so on",
  //   technology: "ReactJS, javaScript, Api, CSS",
  //   source: "https://github.com/CodeWithBilal/react-movie-search-app",
  //   demoLink: "https://codewithbilal.github.io/react-movie-search-app/",
  // },
  // {
  //   id: "07",
  //   image: "/images/project7.png",
  //   title: "PicSome",
  //   description:
  //     " It is an e-Commance picture gallery even though is a Frontend application I added some functionallity that helps user to add his favourate fix on his card in simple way, built with React.js and React-Router using unsplash API",
  //   technology: "ReactJS, javaScript, Api, CSS",
  //   source: "https://github.com/CodeWithBilal/picsome",
  //   demoLink: "https://CodeWithBilal.github.io/picsome/",
  // },
  // {
  //   id: "08",
  //   image: "/images/project8.png",
  //   title: "Robo Friends",
  //   description:
  //     "Robo Friends is a mini application that helps you to find Robots of you choice I created and design it using React.js, during my Fullstack Course on Udemy I used Rorotic APi styled with tachyons predefined CSS",
  //   technology: "ReactJS, javaScript, Api, tachyons CSS",
  //   source: "https://github.com/CodeWithBilal/robofriends",
  //   demoLink: "https://codewithbilal.github.io/robofriends/",
  // },
  // {
  //   id: "09",
  //   image: "/images/project9.png",
  //   title: "Scenic Forest",
  //   description:
  //     "This is a Scenic Beauties Vacation Forest Web site that helps strengers to experience the beauty of the forest for travelers built with HTMl, CSS and JavaScript.",
  //   technology: "javaScript, Api, CSS, HTML5",
  //   source: "https://github.com/CodeWithBilal/scenic-forest",
  //   demoLink: "https://scenicforestsite.netlify.app/",
  // },
  // {
  //   id: "10",
  //   image: "/images/project10.png",
  //   title: "Jake and Elwood",
  //   description:
  //     "This is a copy of a marketing agency website that I created during my Responsive web design course on Scrimba, built using HTML5, CSS, and JavaScript.",
  //   technology: "JavaScript, Api, CSS, HTML5",
  //   source: "https://github.com/CodeWithBilal/jake-and-elwood",
  //   demoLink: "https://jakeandelwoodsite.netlify.app/",
  // },
  // {
  //   id: "11",
  //   image: "/images/project11.png",
  //   title: "Weather App",
  //   description:
  //     "This is a small weather application, that allow user to search and find the condition of his specific search area with alot of information about the weather, built using weather API.",
  //   technology: "JavaScript, React, Api, Tailwind css",
  //   source: "https://github.com/CodeWithBilal/weather-app",
  //   demoLink: "https://weatherapp-bilal.netlify.app/",
  // },
  // {
  //   id: "12",
  //   image: "/images/project12.png",
  //   title: "Dice Game",
  //   description:
  //     "this is a mini Dice games built to for my self to have fun while get tired of coding and also helpful for young kids which not only provides them with a fun option but also helps develop and enhance their Math skills by counting, adding, subtracting, multiplying a set of rolled dice values.",
  //   technology: "JavaScript, HTML5, CSS",
  //   source: "https://github.com/CodeWithBilal/Dice-Game",
  //   demoLink: "https://dicegameme.netlify.app/",
  // },
];

export default myProjects;
